import React from 'react';

import { formatText } from 'core/i18n';

export const NextStep = ({ icon, title, description }) => (
    <div className="step">
        <div className="step-title">
            <img src={icon} />
            <h6>{formatText(title)}</h6>
        </div>
        <p>{formatText(description)}</p>
    </div>
);
